import { MARKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import styles from './styles.module.scss';

const options = {
  renderMark: {
    [MARKS.BOLD]: (text) => <span className={styles.bold}>{text}</span>,
  },
};

export const RichText = ({ text }) => documentToReactComponents(text, options);
